'use client'

import { type FC, useEffect } from 'react'

import { useExperimentsContext } from '../../../experiments/components/ExperimentsContext'
import { adServerGetExperiments } from '../../adServerGetExperiments'
import { useAdServerConfigurationContext } from '../AdServerConfigurationContextProvider'

export const AdServerExperimentActivation: FC = () => {
  const { addExperimentKeysForActivation, experiments } =
    useExperimentsContext()
  const { adServerTargeting } = useAdServerConfigurationContext()
  const {
    context: { pageType },
  } = adServerTargeting

  useEffect(() => {
    const featureKeys = adServerGetExperiments(experiments, pageType).map(
      (experiment) => experiment.name,
    )

    if (featureKeys.length > 0) {
      addExperimentKeysForActivation(featureKeys)
    }
  }, [addExperimentKeysForActivation, experiments, pageType])

  return null
}
